<template>
	<h3>
		Users
	</h3>
	<div class="progress" v-show="false">
	  <div class="progress-bar progress-bar-striped active" role="progressbar"
	  aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width:100%">
	    Loading&hellip;
	  </div>
	</div>

	<div>
		<div class="btn-group">
		  <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
		    User Status ({{ statusFilters.length }}) <span class="caret"></span>
		  </button>
		  <ul class="dropdown-menu">
		  	<li>
		  		<div class="checkbox" style="margin-left: 10px">
			  		<label>
			  			<input type="checkbox" value="Active" v-model="statusFilters">
			  			Active
			  		</label>
			  	</div>
		  	</li>
		  	<li>
		  		<div class="checkbox" style="margin-left: 10px">
			  		<label>
			  			<input type="checkbox" value="Inactive" v-model="statusFilters">
			  			Inactive
			  		</label>
			  	</div>
		  	</li>
		  </ul>
		</div>

		<a href="/users/create" class="btn btn-primary pull-right">New User</a>
	</div>

	<table class="table table-striped">
		<thead>
			<tr>
				<th scope="col">Name</th>
				<th scope="col">Onyen</th>
				<th scope="col">Email</th>
				<th scope="col">Role</th>
				<th scope="col">&nbsp;</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="user in orderedUsers"  :key="user.id">
				<td>{{ user.name }} <span v-if="!user.is_active" class="badge">Inactive</span></td>
				<td>{{ user.onyen }}</td>
				<td>{{ user.email }}</td>
				<td>{{ user.roles.join(', ') }}</td>
				<td class="text-right">
					<a :href="'users/'+user.id+'/edit'" class="btn btn-default btn-sm">edit</a>
				</td>
			</tr>
		</tbody>
	</table>
	
</template>

<script setup>
  import { ref, computed, unref } from 'vue'

  const props = defineProps({ users: Array });
  const sort = ref({ field: 'status', dir: 'asc' });
	const statusFilters = ref(['Active']);

	const orderedUsers = computed(() => {
		const ordered = unref(props.users)
			.slice()
			.filter((user) => {
        let userStatus = user.is_active ? 'Active' : 'Inactive';
        return unref(statusFilters).includes(userStatus);
    }).map(function (user) {
			return {
				id: user.id,
				name: [user.first_name,user.last_name].join(' '),
				onyen: user.onyen,
				email: user.email,
				roles: user.roles?.map(role => role.name) || [],
				is_active: user.is_active,
			}
		});

		return ordered;
	})
</script>

<style scoped>
	.btn-toggle:focus {
		outline: none;
	}
	.btn-toggle.btn-default:focus {
		background-color: #fff;
		border-color: #ccc;
	}
</style>